export default [{
	path: '/auth',
	component: () => import(/* webpackChunkName: 'Auth' */ 'src/layouts/Auth.vue'),
	children: [
		{
			alias: '/login',
			path: 'login',
			component: () => import(/* webpackChunkName: 'Auth' */ './Login.vue'),
			props: route => ({ ...route.query, ...route.params }),
			meta: {
				title: 'Log In'
			}
		},
		{
			alias: '/signup',
			path: 'signup',
			component: () => import(/* webpackChunkName: 'Auth' */ './Signup.vue'),
			props: route => ({ ...route.query, ...route.params }),
			meta: {
				title: 'Sign Up'
			}
		},
		{
			alias: '/forgot-password',
			path: 'forgot-password',
			name: 'forgot-password',
			component: () => import(/* webpackChunkName: 'ForgotPassword' */ './ForgotPassword.vue'),
			meta: {
				title: 'Recover Password'
			}
		},
		{
			alias: 'reset-password',
			path: '/reset-password',
			name: 'reset-password',
			component: () => import(/* webpackChunkName: 'ResetPassword' */ './ResetPassword.vue'),
			props: route => ({ ...route.query, ...route.params }),
			meta: {
				title: 'Reset Your Password'
			}
		},
		{
			alias: 'accept-invite',
			path: '/accept-invite',
			name: 'accept-invite',
			component: () => import(/* webpackChunkName: 'AcceptInvite' */ './AcceptInvite.vue'),
			props: route => ({ ...route.query, ...route.params }),
			meta: {
				title: 'Log In'
			}
		},
		{
			alias: 'accept-invite-login',
			path: '/accept-invite-login',
			name: 'accept-invite-login',
			component: () => import(/* webpackChunkName: 'AcceptInviteLogin' */ './AcceptInviteLogin.vue'),
			props: route => ({ ...route.query, ...route.params }),
			meta: {
				title: 'Log In',
				showBackButton: true
			}
		},
		{
			alias: 'api-connection',
			path: '/api-connection',
			name: 'api-connection',
			component: () => import(/* webpackChunkName: 'ApiConnection' */ './ApiConnection.vue'),
			props: route => ({ ...route.query, ...route.params })
		}
	]
}];